export const DEFAULT_SURFACE = 20

export interface IProduct {
  idp: string
  idd: string
  categorie: string
  sous_categorie: string
  f_libelle: string
  typed: string
  ref_base: string
  condition_type: string
  conditionnement: string
  titre_base: string
  description_base: string
  dimension: string
  hauteur_utile_mm: string
  hauteur_totale_mm: string
  surface: string
  epaisseur: string
  mini_commande: string
  photo: string
  enligne: string
  titre_dec: string
  ref_suite: string
  coloris: string
  couleur: string
  longueur: string
  echantillon: string
  tarif_1: string
  tarif_10_ml: string
  tarif_50_ml: string
  tarif_100_ml: string
  tarif_200_ml: string
  id_famille: string
  ref_unique: string
  photosim: string
}

export interface ChoosenAccessoire {
  product: IProduct
  /** Nombre d'objet ou de mètre linéaire */
  quantity: number
  /** Nombre de produits à commander */
  amount: number
}

export const DEFAULT_PRODUCT: IProduct = {
  idp: '',
  idd: '',
  categorie: '',
  sous_categorie: '',
  f_libelle: '',
  typed: '',
  ref_base: '',
  condition_type: '',
  conditionnement: '',
  titre_base: '',
  description_base: '',
  dimension: '',
  hauteur_utile_mm: '',
  hauteur_totale_mm: '',
  surface: '',
  epaisseur: '',
  mini_commande: '',
  photo: '',
  enligne: '',
  titre_dec: '',
  ref_suite: '',
  coloris: '',
  couleur: '',
  longueur: '',
  echantillon: '',
  tarif_1: '',
  tarif_10_ml: '',
  tarif_50_ml: '',
  tarif_100_ml: '',
  tarif_200_ml: '',
  id_famille: '',
  ref_unique: '',
  photosim: '',
}

export enum ACCESSOIRES {
  COMMUN = 'Accessoires communs',
  U = 'U',
  CONNECTEUR = 'Connecteurs',
  UNIS = 'Unis',
  ANGLE_EXTERIEUR = 'Angles extérieurs',
  ANGLE_INTERIEUR = 'Angles intérieurs',
}

export const onlyUnique = (value: any, index: number, self: any[]) => {
  return self.indexOf(value) === index;
}

export const isDefined = (value: any, index: number, self: any[]) => {
  return !!value;
}

export const getImgUrl = (pic: string): string => {
  if (!pic) return ''
  return require(`@/assets/${pic}`)
}

export const capitalize = (s: string | undefined) => {
  if (typeof s !== 'string') return ''
  s = s.toLowerCase()
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const glouton = (elements: number[], length: number): number => {
  let sortedElements = elements.sort((a, b) => b - a)
  let result = 0
  let reste = length
  let somethingDone = false
  let notTreatedElements = []

  while (sortedElements.length > 0) {
    for (const element of sortedElements) {
      if (reste - element >= 0) {
        reste -= element
        somethingDone = true
      } else {
        notTreatedElements.push(element)
      }
    }

    sortedElements = notTreatedElements
    notTreatedElements = []
    if (somethingDone) {
      result++
      reste = length
    } else {
      console.error(`Error glouton : ${elements}, ${length}`)
      return -1
    }
    somethingDone = false
  }

  return result
}

export const howManyNeedForFill = (elementSurface: number, surface: number): number => {
  let leavingSurface = surface
  let count = 0

  if (elementSurface <= 0) {
    return 0
  }

  while (leavingSurface > 0) {
    leavingSurface -= elementSurface
    count++
  }

  return count
}

export const ID_VIS = '114'
export const ID_ROULEAU = '115'
export const ID_U_DEPART_1 = '116'
export const ID_U_DEPART_2 = '117'

export const store: { currentProductInfo: IProduct | null } = {
  currentProductInfo: null
}

export const BASE_URL = `https://www.bardagefacile.fr/images/produits/`
